// extracted by mini-css-extract-plugin
export default {"head":"List_head__Ndpnl","headMain":"List_headMain__q7-06","pad0":"List_pad0__bi8Hb","btntbl":"List_btntbl__HlSGo","id":"List_id__RIauA","btns":"List_btns__cPu5W"};